import React, { useState, useEffect, useRef, useContext } from "react";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";

import Card from "../../../Components/Card/Card";
import AgGrid from "../../../Components/Tables/AgGrid/AgGrid";
import { setTitlePage } from "../../../Services/Config/ConfigService";
import { getLabel } from "../../../Services/Language/LanguageService";
import { baseLang } from "../../../Lang/BaseLang";
import { ConfigContext } from "../../../Context/ConfigContext/ConfigContext";
import { AuthContext } from "../../../Context/AuthContext/AuthContext";

import { getPermisosGenerales } from "../../../API/Global/PermisosGenerales/PermisosGeneralesRequest";
import PermisosGeneralesCrud from "./PermisosGeneralesCRUD/PermisosGneralesCRUD";
// import AreaCrudModal from "./AreasCrud/AreasCrudModal";



export const PermisosGeneralesScreen = () => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);

  const [permisosGenerales, setPermisosGenerales] = useState("");
  const [selected, setSelected] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [loading, setLoading] = useState(true);

  const getInfo = async () => {
    setLoading(true);
    const a = await getPermisosGenerales();
    setPermisosGenerales(a);
    setLoading(false);
  };


  const colums = [
    {
      field: "IdPermisoGeneral",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      className:"XXsmall",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "NombrePermiso",
      header: "Nombre",
      headerEn: "Name",
      flex: 1,
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    { field: "Estado", header: "Estado", headerEn: "State", width: 100 },
    {
      field: "Descripcion",
      header: "Descripción",
      headerEn: "Description",
    },
    // { field: "IdTipo", header: "Id Tipo", headerEn: "Id Tipo" },
    { field: "Type", header: "Tipo", headerEn: "Tipo" },
    { field: "TypeCategory", header: "Categoría Tipo", headerEn: "Type Category" },
    {
      field: "IdPermisoGeneral",
      className: "",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          className: "custom-tooltip",
          onClick: (rowData) => {
            setShowDialog(true);
            setSelected(rowData);
          },
        },
      ],
    },
  ];

  const table = {
    Columns: colums,
    Data: permisosGenerales,
    loading: loading,
  };

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "permisosGenerales", config.language));
    getInfo();
}, [])

  return (
    <div
      className=" p-fluid px-4"
      style={{ width: "100%", height: "100%", margin: "auto" }}
    >
      <Toast ref={toast}></Toast>
      <Card
        titulo={
          <div className="botones">

            <h3>{getLabel(baseLang, "permisosGenerales", config.language)}</h3>
            <Button icon="pi pi-refresh" onClick={getInfo} />
            <Button icon='pi pi-plus' severity='success' onClick={() => {
                        setShowDialog(true);
                        setSelected(null);
                    }} />
          </div>
        }
        contenido={
          <div className="p-4" style={{ height: "90vh" }}>
            <AgGrid table={table} />
          </div>
        }
      />
      {showDialog && <PermisosGeneralesCrud toastRef={toast} showDialog={showDialog} selected={selected} setShowDialog={setShowDialog} getInfo={getInfo} modo={selected ? "Editar" : "Crear"}/>}

    </div>
  );
};

export default PermisosGeneralesScreen;
